import { LobbyImage } from '@colonist/types';
import { createDivIn, createImgIn, createParagraphIn, setElementOnClick } from '../../ui_utils/DomUtils.ts';
export class UIComponentItemScrollCell {
    updateInteractability(isGuest) {
        this.setView(isGuest);
        if (this.shouldDisableOnClick(isGuest)) {
            setElementOnClick(this.container, ()=>undefined);
            return;
        }
        if (this.shouldShowInfoOnClick(isGuest)) {
            this.setInfoOnClick();
        } else {
            this.setOnClick();
        }
    }
    init() {
        this.setOnClick();
        this.updateCellView();
    }
    updateCellView() {
        if (!this.available) this.setUnavailable();
        if (this.selected) this.setSelected();
        if (this.bannerText) this.createBanner(this.bannerText);
    }
    createBanner(bannerText) {
        const banner = createDivIn(this.container, 'badge-green badge-sm');
        createParagraphIn(banner, bannerText, '');
    }
    setView(isGuest) {
        this.container.classList.toggle('guest-view', isGuest);
    }
    setUnavailable() {
        this.container.classList.add('unavailable');
        createImgIn(this.container, LobbyImage.Lock, 'item-scroll-cell-lock');
        if (this.canToggle) this.setInfoOnClick();
    }
    setSelected() {
        this.container.classList.add('selected');
    }
    shouldDisableOnClick(isGuest) {
        if (isGuest && this.canToggle) return true;
        return false;
    }
    shouldShowInfoOnClick(isGuest) {
        if (isGuest) return true;
        if (this.canToggle && this.available) return false;
        if (this.canToggle && !this.available) return true;
        if (this.selected) return true;
        return false;
    }
    setOnClick() {
        setElementOnClick(this.container, this.clickAction);
    }
    setInfoOnClick() {
        if (this.infoAction == undefined) {
            setElementOnClick(this.container, ()=>undefined);
            return;
        }
        setElementOnClick(this.container, this.infoAction);
    }
    constructor(container, data){
        this.container = createDivIn(container, 'item-scroll-cell');
        this.name = data.name;
        const image = createImgIn(this.container, data.image, 'item-scroll-cell-image');
        const text = createParagraphIn(this.container, this.name, 'item-scroll-cell-text');
        image.draggable = false;
        if (text.textContent) text.textContent = text.textContent.replace(/-/g, '\u2011');
        if (data.showInfoIcon) createImgIn(this.container, LobbyImage.InfoIcon, 'item-scroll-cell-info-icon');
        this.available = data.available;
        this.selected = data.selected;
        var _data_canToggle;
        this.canToggle = (_data_canToggle = data.canToggle) !== null && _data_canToggle !== void 0 ? _data_canToggle : false;
        var _data_bannerText;
        this.bannerText = (_data_bannerText = data.bannerText) !== null && _data_bannerText !== void 0 ? _data_bannerText : undefined;
        this.clickAction = data.clickAction;
        this.infoAction = data.infoAction;
        this.init();
    }
}
